import React from 'react'
import { Link } from "react-router"

export default function QuickAction() {
  return (
    <div
      id="quick-actions-card"
      className="bg-white rounded-2xl shadow-sm border border-[#e5e7eb] px-7 py-6"
    >
      <div className="font-semibold text-lg text-[#1e293b] mb-4">
        Quick Actions
      </div>
      <div className="flex flex-col gap-3">
        <Link to="/product/add" className="flex items-center gap-3 px-4 py-3 rounded-lg bg-[#3b82f6] text-white font-semibold hover:bg-[#2563eb] transition">
          <i className="fa-solid fa-plus"></i> Add New Product
        </Link>
        <Link to="/user/add-user" className="flex items-center gap-3 px-4 py-3 rounded-lg bg-[#f59e42] text-white font-semibold hover:bg-[#d97706] transition">
          <i className="fa-solid fa-user-plus"></i> Add User
        </Link>
        <Link to="/supplier/add-vendor" className="flex items-center gap-3 px-4 py-3 rounded-lg bg-[#10b981] text-white font-semibold hover:bg-[#059669] transition">
          <i className="fa-solid fa-truck"></i> Add Vendor
        </Link>
      </div>
    </div>
  )
}
